import styled from 'styled-components';

import {Device} from '../../../constants';

const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  justify-content: center;

  @media screen and ${Device.laptopL} {
    width: 75%;
  }

  @media screen and ${Device.tablet} {
    width: 100%;
    padding: 1em;
    margin-bottom: 2em;
  }
`;

export default StyledContentWrapper;
